<template>
    <v-container v-click-outside="{ handler: onClickOutside, include }" fluid class="mx-0 px-0">
        <v-navigation-drawer
            v-model="drawer"
            fixed
            class="drawer pt-15 elevation-10"
        >
            <div>
                <v-img
                    src="@/assets/logo_kiddy_motion-01.png"
                    contain
                    class="mx-auto mb-4 included"
                    width="200"
                />
            </div>
            <v-list
                nav
                dense
                class="py-0"
            >
                <div v-for="(menuItem, index) in filteredMenu" :key="index" @click="setDrawer">
                    <v-list-item :to="menuItem.to" link>
                        <v-list-item-icon v-if="menuItem.icon">
                            <v-icon color="#6499fa">{{ menuItem.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title v-if="menuItem.title">{{ $t(menuItem.title) }}</v-list-item-title>
                    </v-list-item>
                </div>
            </v-list>
        </v-navigation-drawer>
    </v-container>
</template>

<script>
    export default {
        name: 'Sidebar',
        data() {
            return {
                menu: [
                    { title: 'menu.home', to: '/', icon: 'mdi-finance', roles: ['ROLE_ADMIN'] },
                    { title: 'menu.users', to: '/users', icon: 'mdi-account', roles: ['ROLE_ADMIN'] },
                    { title: 'menu.coaches', to: '/coaches', icon: 'mdi-whistle', roles: ['ROLE_ADMIN', 'ROLE_STATS'] },
                    { title: 'menu.sports', to: '/sports', icon: 'mdi-yoga', roles: ['ROLE_ADMIN'] },
                    { title: 'menu.sportClasses', to: '/sportClasses', icon: 'mdi-account-group', roles: ['ROLE_ADMIN'] },
                    { title: 'menu.memberships', to: '/memberships', icon: 'mdi-card-account-details', roles: ['ROLE_ADMIN'] }
                ]
            }
        },
        computed: {
            drawer: {
                get() {
                    return this.$store.getters.getDrawer
                },
                set(value) {
                    return value
                }
            },
            // Filter menu items by roles: show item when it has no roles OR the user has at least one required role
            filteredMenu() {
                // return this.menu.filter(menuItem => {
                //     if (!menuItem.roles || !menuItem.roles.length) return true
                //     const roles = this.$store.getters.getUserRoles
                //     if (!roles || !roles.length) return false
                //     return menuItem.roles.some(r => roles.includes(r))
                // })
                return this.menu
            }
        },
        methods: {
            onClickOutside() {
                this.setDrawer()
            },
            setDrawer() {
                if (this.drawer) {
                    this.$store.dispatch('setDrawer', !this.drawer)
                }
            },
            include() {
                return [document.querySelector('.included')]
            }
        }
    }
</script>

<style scoped>

a {
    color: #0060B6;
    text-decoration: none;
}

a:hover {
    color:#00A0C6;
    text-decoration:none;
    cursor:pointer;
}
.sub-text{
    font-size: 0.8rem;
    color: black;
}
.container {
    align-self: center;
    height: 100%;
}
</style>
